<template>
  <div>
    <v-img
      src="https://images.unsplash.com/photo-1509822929063-6b6cfc9b42f2?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80"
      gradient="#FFFFFF00, #000000"
      max-height="35vh"
    >
      <v-row>
        <v-col class="mt-16" align="center">
          <div class="v-centered">
            <span class="primary--text text-md-h2 text-h3 font-weight-bold"
              >Authentication</span
            >
          </div>
        </v-col>
      </v-row>
    </v-img>
    <div class="px-8">
      <v-row>
        <v-col align="center">
          <div class="v-centered remaining-height">
            <span class="primary--text text-md-h4 text-h5 font-weight-bold"
              >You're currently getting authenticated... Click
              <router-link to="/redirectSpotify">here</router-link> if it didn't
              work!</span
            >
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "auth",
  title: "Auth",

  data() {
    return {
      authCode: "-1",
      accessToken: "-1",
      tokenType: "",
      redirect: "/",
    };
  },
  mounted() {
    if (this.$route.query.code) {
      this.authCode = this.$route.query.code;
      this.handleAuth();
    } else {
      let Notify = {
        duration: 4000,
        type: "error",
        headline: "Spotify-Login",
        message: "Unable to login... Try again later!",
      };
      this.$globalState.addNotification(Notify);
    }
    if (this.$cookies.get("authRedirect")) {
      this.redirect = this.$cookies.get("authRedirect");
      this.$cookies.remove("authRedirect");
    }
  },
  methods: {
    handleAuth: async function () {
      let payload = {
        authCode: this.authCode,
        redirectUri: this.$siteUrl + "/auth",
      };
      let response = await fetch(this.$apiUrl + "/initAuth", {
        method: "POST",
        body: JSON.stringify(payload),
      });

      let responseData = await response.json();

      let Notify = {
        duration: 4000,
        type: "error",
        headline: "Spotify-Login",
        message: "Failed to login! Try again later...",
      };

      if (responseData.state) {
        Notify.type = "success";
        Notify.message =
          "Successfully logged in: " + responseData.userProfile.id;

        this.$cookies.set("authToken", responseData.authToken);
        this.$globalState.userProfile = responseData.userProfile;
      }

      this.$globalState.addNotification(Notify);

      if (responseData.state) {
        this.$router.push(this.redirect);
      }
    },
  },
};
</script>

<style scoped>
.v-centered {
  display: grid;
  place-items: center;
  height: 20vh;
}
.remaining-height {
  height: 60vh;
}
</style>